import { AppBar, Box, Container, Icon, Toolbar, Typography } from "@mui/material";

export default function HeaderAppBar() {
    return (<AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            rita.library
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
}